module.exports = __webpack_public_path__ + "static/media/5.b3f9c426.svg";